import { Avatar as MuiAvatar, styled } from '@mui/material';

const avatarSize = 40;

export const StyledAvatar = styled(MuiAvatar)`
  width: ${avatarSize};
  height: ${avatarSize};
`;
